import { Component, OnInit, Input } from '@angular/core';
import { MasterDetailComponent } from '../master-detail/master-detail.component';


@Component({
  selector: 'app-contact-detail',
  templateUrl: './contact-detail.component.html',
  styles: []
})
export class ContactDetailComponent extends MasterDetailComponent {

  @Input() dataId: string

  contact = null

  async ngOnInit() {

    if (this.dataId) {
      this.contact = await this.fetch(this.dataId)
    }
  }

  fetch(id) {

    return this.ERPAPI.get('hr/contact/' + id).then(res => res.object)
  }
}



// WEBPACK FOOTER //
// ./src/app/components/detail/contact-detail/contact-detail.component.ts